import * as z from 'zod';
export const SuggestionItemSchema = z.object({
    name: z.string(),
    score: z.number().min(0).max(1),
});
export const SuggestionSchema = z.object({
    suggestions: z.array(SuggestionItemSchema).min(1).max(3).meta({
        description: 'Up to 3 possibly better suggestions, sorted by score descending',
    }),
});
//# sourceMappingURL=suggest.js.map